import { plainToClass } from 'class-transformer';
import { DateUpdatedSection } from '../../../../shared/components/date-updated-section/date-updated-section.view';
import { RemoveElementFromArray } from '../../../../shared/scripts/array-functions';
import { RenderNullableNumber } from '../../../../shared/scripts/table-functions';
import { RenderExecutiveSummaryNumber } from '../../../../shared/scripts/table-functions';
import { ExecutiveSummaryEntry } from './executive-summary.entities';

export class ExecutiveSummaryPage {
    dataTables: any[] = [];
    openParentHashes: string[] = [];

    constructor(DataJson: any, LastUpdatedJson: any) {
        $(() => {
            console.log("ExecutiveSummaryPage loaded");
            console.log("LastUpdatedJson", LastUpdatedJson);
            new DateUpdatedSection(LastUpdatedJson);

            let data: ExecutiveSummaryEntry[] = plainToClass(ExecutiveSummaryEntry, <ExecutiveSummaryEntry[]>DataJson);
            data.forEach((element: ExecutiveSummaryEntry) => element.initialize());

            let screenedRow: ExecutiveSummaryEntry = data.find(entry => entry.Label == "Screened (Post Consent)");
            let randomizedRow: ExecutiveSummaryEntry = data.find(entry => entry.Label == "Randomized");

            data.forEach((element: ExecutiveSummaryEntry) => {
                if (element.Type == 0 || element.Type == 2 || element.Type == 4) {
                    if (element.Group == "Participant-Screen") element.createDisplayValues(screenedRow);
                    else if (element.Group == "Participant-Random") element.createDisplayValues(randomizedRow);
                }
            });

            this.initializeSection(data.filter((entry: ExecutiveSummaryEntry) => entry.Group == "Site"), "executive-summary-sites-table", "Sites");
            this.initializeSection(data.filter((entry: ExecutiveSummaryEntry) => entry.Group == "Participant-Screen" || entry.Group == "Participant-Random"), "executive-summary-participants-table", "Participants");

            this.setRowVisibility();
        });
    }

    private initializeSection(data: ExecutiveSummaryEntry[], tableId: string, tableTitle: string): void {
        let parentRows: ExecutiveSummaryEntry[] = data.filter((entry: ExecutiveSummaryEntry) => (entry.Type != 2) && (entry.Type != 5) && (entry.Type != 6));
        parentRows.sort((a: ExecutiveSummaryEntry, b: ExecutiveSummaryEntry) => a.OrderBy - b.OrderBy);

        let alphabeticalChildrenRows: ExecutiveSummaryEntry[] = data.filter((entry: ExecutiveSummaryEntry) => entry.Type == 2 || entry.Type == 5);
        alphabeticalChildrenRows.sort((a: ExecutiveSummaryEntry, b: ExecutiveSummaryEntry) => {
            if (a.Type === 5) {
                if (a.Label.startsWith('Unknown')) return 1;
                if (b.Label.startsWith('Unknown')) return -1;
                if (a.Label.startsWith('Other')) return 1;
                if (b.Label.startsWith('Other')) return -1;
            }
            return a.Label.localeCompare(b.Label);
        });

        let sortedChildrenRows: ExecutiveSummaryEntry[] = data.filter((entry: ExecutiveSummaryEntry) => entry.Type == 6);
        sortedChildrenRows.sort((a: ExecutiveSummaryEntry, b: ExecutiveSummaryEntry) => a.OrderBy - b.OrderBy);

        let childrenRows: ExecutiveSummaryEntry[] = [...alphabeticalChildrenRows, ...sortedChildrenRows];

        let allRows: ExecutiveSummaryEntry[] = [];
        for (let i = 0; i < parentRows.length; ++i) {
            parentRows[i].HasChildren = (parentRows[i].Type == 1) || (parentRows[i].Type == 4);
            parentRows[i].ParentHash = "AlwaysShow";
            allRows.push(parentRows[i]);

            if ((parentRows[i].Type == 1) || (parentRows[i].Type == 4)) {
                let childrenForParent: ExecutiveSummaryEntry[] = childrenRows.filter((childRow: ExecutiveSummaryEntry) => childRow.ParentId == parentRows[i].Id);
                for (let j = 0; j < childrenForParent.length; ++j) {
                    childrenForParent[j].ParentHash = "ChildOf" + parentRows[i].Id;
                    childrenForParent[j].HasChildren = false;
                    childrenForParent[j].IsLastChild = (j == (childrenForParent.length - 1));
                    allRows.push(childrenForParent[j]);

                    if (!this.openParentHashes.includes(childrenForParent[j].ParentHash)) { this.openParentHashes.push(childrenForParent[j].ParentHash); }
                }
            }
        }
        this.initializeTable(allRows, tableId, tableTitle);
    }

    private initializeTable(data: ExecutiveSummaryEntry[], tableId: string, tableTitle: string): void {
        let dataTable: any = $('#' + tableId).DataTable({
            //"dom": '<"top-controls"B0>>rtip',
            "dom": 'rt',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: false,
            //scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            ordering: false,
            fixedHeader: false,
            columns: [
                { className: 'details-control', orderable: false, data: null, defaultContent: '', width: '5px' },
                //{ data: "Label", title: `<h5 class="">${tableTitle}</h5>`, className: "text-left font-size12", width: '400px' },
                { data: "Label", title: "", className: "text-left font-size12", width: '400px' },
                { data: "DisplayValues.0", title: 'REVERSE-LC', className: "text-center font-size12 nowrap", width: '100px', render: RenderNullableNumber },
                { data: "DisplayValues.1", title: "TOTAL <sup>1</sup>", className: "text-center font-size12 nowrap", width: '100px', render: RenderExecutiveSummaryNumber },
                { data: "OrderBy", title: "", visible: false },
                { data: "ParentHash", title: "", visible: false, searchable: true },
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                }
            ],
            data: data,
            rowCallback: (row, rowData: ExecutiveSummaryEntry) => {
                if (!rowData.HasChildren) {
                    $('td:eq(0)', row).removeClass('details-control');

                    if (rowData.Type == 2 || rowData.Type == 5 || rowData.Type == 6) {
                        $(row).addClass('child-row');

                        if (rowData.IsLastChild) {
                            $(row).addClass('last');
                        }
                    }
                }
                else {
                    $(row).addClass('selectable');
                    if (rowData.Type == 4) {
                        $(row).addClass('reason-row');
                    }
                }

                let cssIndent: string = "indent-" + rowData.Indent;
                $('td:eq(1)', row).addClass(cssIndent);

                if (rowData.Type == 3) {
                    $('td:eq(1)', row).addClass('font-italic font-bold');
                }
            }
        });

        dataTable.on('click', 'tbody tr', (event) => {

            let selectedEntry: ExecutiveSummaryEntry = dataTable.row($(event.currentTarget)).data();
            let tr: any = $(event.currentTarget).closest('tr');
            // console.log(selectedEntry);

            if (!selectedEntry) {
                return;
            }

            if (selectedEntry.HasChildren) {
                let parentHash: string = "ChildOf" + selectedEntry.Id;

                if (this.openParentHashes.includes(parentHash)) {
                    RemoveElementFromArray(this.openParentHashes, parentHash);
                    tr.addClass('opened');
                }
                else {
                    this.openParentHashes.push(parentHash);
                    tr.removeClass('opened');
                }
                this.setRowVisibility();
            }
        });

        this.dataTables.push(dataTable);
    }

    private setRowVisibility(): any {
        let filterString: string = "";

        if (this.openParentHashes.length == 0) { filterString = "ShowEverything"; }
        else {
            this.openParentHashes.forEach((parentHash: string) => {
                if (filterString.length > 0) filterString += "|";
                filterString += parentHash;
            });
        }

        filterString = "^((?!" + filterString + ").)*$";

        this.dataTables.forEach((dt: any) => { dt.columns(5).search(filterString, true, false).draw(); });
    }
}